import { type AlgoliaRecord } from '../../../algolia'

export const productSearchAlgoliaAccessorGetFormattedUnitQuantity = (
  algoliaProduct: AlgoliaRecord,
): string | null => {
  const { unit, unitQuantityString } = algoliaProduct

  return unitQuantityString && unit ? `${unitQuantityString} ${unit}` : null
}
